import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OphLoadingModule} from '../oph-loading/oph-loading.module';

@Component({
  selector: 'oph-slide-toggle',
  standalone: true,
  imports: [OphLoadingModule],
  templateUrl: './oph-slide-toggle.component.html',
  styleUrl: './oph-slide-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphSlideToggleComponent {
  @Input() checked: boolean;
  @Input() disabled = false;
  @Input() loading = false;

  @Output() toggle = new EventEmitter<boolean>();

  onToggle() {
    this.toggle.emit(!this.checked);
  }
}
